import { RootState } from "../../../system/redux/store/community-finder-redux-store";

export const selectMapZoomed = (state: RootState) =>
	state?.mapSettings?.mapZoomed;
